export enum GDPRConsentType {
  IntegrationPolicy = "IntegrationPolicy",
  Marketing = "Marketing",
  JobMailing = "JobMailing",
  JobMailingEmail = "JobMailingEmail",
  JobMailingSms = "JobMailingSms",
  JobMailingCampaignEmail = "JobMailingCampaignEmail"
}

export const JOB_MAILING_SUB_CONSENTS = [
  GDPRConsentType.JobMailingEmail,
  GDPRConsentType.JobMailingSms,
  GDPRConsentType.JobMailingCampaignEmail
] as const;
